import { fontClass } from "@/config/fontConfig/fontClass"
import { isHeadingLevel } from "@/src/utils/a11y/headingLevel"
import { type HeadingFontKey, type HeadingLevel } from "@/types/gc-modules-types"
import { clsx } from "@/src/utils/clsx"

type HeadingElementProps = {
    isAboveTheFold: boolean
    text: string
    type?: HeadingLevel | null
    levelOverride?: HeadingLevel
    styleKey?: HeadingFontKey
    className?: string
}

export default function HeadingElement({
    text,
    type,
    levelOverride,
    styleKey = "",
    className
}: HeadingElementProps) {
    if (!text?.trim()) return null
    // Visual styling is always derived from `styleKey`. The page template owns
    // the document `h1`; CMS `type: h1` is remapped unless a caller opts in.
    // Sanity yields `null` for an unset level, which a default parameter would not catch.
    const authoredLevel = isHeadingLevel(type) ? type : "h2"
    const Tag = levelOverride ?? (authoredLevel === "h1" ? "h2" : authoredLevel)

    return <Tag className={clsx(className, fontClass(styleKey))}>{text}</Tag>
}
